// General FAQ — single source of truth for both server and client.
// Server uses: llms.txt / llms-full.txt content. Client uses: FaqPage
// (the visible /faq route) and its FAQPage JSON-LD via @shared/faqs.
//
// City-specific FAQs live with each city in src/shared/cities.ts. These
// entries are the site-wide ones surfaced on /faq.

export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: "What are nicotine pouches?",
    answer:
      "Nicotine pouches are small, discreet pouches containing nicotine and other ingredients but no tobacco. They are placed between the gum and upper lip, allowing nicotine absorption through the mouth lining. They come in various flavors and strengths, offering a smokeless and spit-free alternative to traditional tobacco products.",
  },
  {
    question: "How do I use ZeroSmoke nicotine pouches?",
    answer:
      "Simply take one pouch from the can and place it between your gum and upper lip. You'll feel the nicotine release within 5-10 minutes. Keep it in for 20-40 minutes, then dispose of it responsibly. Start with lighter strengths if you're a first-timer.",
  },
  {
    question: "Are nicotine pouches safe?",
    answer:
      "Nicotine pouches are tobacco-free and don't involve combustion, making them a smoke-free alternative. They contain no tar, ash, or tobacco leaf. However, they do contain nicotine which is addictive. They are intended for adult nicotine users only.",
  },
  {
    question: "What flavors and strengths are available?",
    answer:
      "We offer a wide range from brands like ZYN, VELO, VELO Shift, Pablo, White Fox, and CLEW. Flavors include mint, berry, citrus, tropical, coffee, and more. Strengths range from light (3-6mg) for beginners to extra strong (16.5-50mg) for experienced users.",
  },
  {
    question: "Where can I buy ZeroSmoke nicotine pouches?",
    answer:
      "You can buy nicotine pouches directly through our website zerosmoke.in. We offer free shipping across India on orders of ₹5,000 or more, with discreet packaging and fast delivery.",
  },
  {
    question: "How long does shipping take?",
    answer:
      "We typically ship within 24 hours of order confirmation. Delivery takes 3-7 business days depending on your location within India. Free shipping is available on orders above ₹5,000.",
  },
  {
    question: "Can I return or exchange products?",
    answer:
      "Due to the nature of our products, we accept returns only for unopened, sealed items within 7 days of delivery. Please contact us at zerosmoke2026@gmail.com for any return or exchange requests.",
  },
  {
    question: "How do ZS Coins work?",
    answer:
      "Every delivered order earns you ZS Coins back — 1% to 3% of the order value depending on your loyalty rank, so higher ranks earn more. Each coin is worth ₹1, and you can redeem them to cover up to 20% of a future order. Coins expire 12 months after you earn them, and we always spend your soonest-to-expire coins first. You can track your balance and activity on the Rewards page.",
  },
  {
    question: "How does the ZeroSmoke referral program work?",
    answer:
      "Share your referral code or link from the Rewards page. When a friend signs up with it, they get a 300-coin welcome bonus that unlocks after their first delivered order — and you earn 300 coins once that order is delivered. A referral code can be used once, by a new account, before their first delivered order.",
  },
  {
    question: "What happens to my coins if I cancel or return an order?",
    answer:
      "Coins you earned from an order that is later cancelled or returned are reversed, along with any referral rewards tied to that order. Coins you already redeemed on a completed order are not affected.",
  },
];
